import { Field } from 'components/Wizards/Field/Field'
import { SafeNumberInput } from 'almanac-ui/TextInputField/SafeNumberInput'
import Styles from './AudiencePreferences.module.scss'

const MIN_AGE = 18
const MAX_AGE = 100

type Props = {
  minAge?: number
  maxAge?: number
  onMinAgeUpdate: (age: number | undefined) => void
  onMaxAgeUpdate: (age: number | undefined) => void
}

const Age = ({ minAge, maxAge, onMinAgeUpdate, onMaxAgeUpdate }: Props) => {
  return (
    <Field label="Age" labelType="label" data-testid="age-preferences">
      <div className={Styles.ageContainer}>
        <div className={Styles.inputGroup}>
          <SafeNumberInput
            className={Styles.ageInput}
            aria-label="Min age"
            name="min-age"
            minValue={MIN_AGE}
            maxValue={MAX_AGE}
            value={minAge}
            onChange={onMinAgeUpdate}
            placeholder={String(MIN_AGE)}
            decimalPrecision={0}
            size="lg"
          />
        </div>
        <span className={Styles.separator}>to</span>
        <div className={Styles.inputGroup}>
          <SafeNumberInput
            className={Styles.ageInput}
            aria-label="Max age"
            name="max-age"
            minValue={MIN_AGE}
            maxValue={MAX_AGE}
            value={maxAge}
            onChange={onMaxAgeUpdate}
            placeholder={String(MAX_AGE)}
            decimalPrecision={0}
            size="lg"
          />
        </div>
      </div>
    </Field>
  )
}

export { Age }
